<template>
    <div>
        <Detail type="2"/>
    </div>
</template>
<script>
import Detail from '../components/detail.vue';
export default {
data(){
    return {};
},
components:{Detail}
};
</script>
<style lang="less" scoped>

</style>
